import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.repeat.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Navbar, Sidebar, AppMain } from './components';
import ResizeMixin from './mixin/ResizeHandler';
import { getUserId, setPer, setOrgId, getToken, setFirstBranch, setBaseurl } from '@/utils/auth';
import { refreshMessage, refreshTodo, getSystemInnerList } from '@/api/message';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import system from '@/store/modules/system';
import { set } from 'js-cookie';
import PCMPlayer from 'pcm-player';
export default {
  name: 'Layout',
  components: {
    Navbar: Navbar,
    Sidebar: Sidebar,
    AppMain: AppMain
  },
  mixins: [ResizeMixin],
  provide: function provide() {
    return {
      dict_info: this.dict
    };
  },
  directives: {
    drag: {
      // 指令的定义
      bind: function bind(el) {
        var oDiv = el; // 获取当前元素
        oDiv.onmousedown = function (e) {
          // 算出鼠标相对元素的位置
          var disX = e.clientX - oDiv.offsetLeft;
          var disY = e.clientY - oDiv.offsetTop;
          document.onmousemove = function (e) {
            // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
            var left = e.clientX - disX;
            var top = e.clientY - disY;
            oDiv.style.left = "".concat(left, "px");
            oDiv.style.top = "".concat(top, "px");
          };
          document.onmouseup = function () {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    }
  },
  data: function data() {
    var _this = this;
    return {
      dict: JSON.parse(sessionStorage.getItem('dist_info')),
      timer: null,
      robotModalVisible: false,
      drawer: false,
      isShowBtnGroup: false,
      question: '',
      answer: '',
      answerMsg: [],
      images: '',
      assistantImages: require('../assets/qaRobot.png'),
      items: [],
      systemList: [],
      disClick: false,
      breakPromise: false,
      cancelBtn: null,
      qaTitle: 'question',
      options: {
        assistant: '晓合助手',
        riQa: '合规政策问答',
        instQa: '制度问答'
      },
      chatId: '',
      chatDraw: false,
      chatAnswer: '',
      chatAnswerMsg: [],
      delay: true,
      model: 'assistant',
      change: false,
      isSend: false,
      sendModel: 'assistant',
      instAnswerMsg: [],
      riAnswerMsg: [],
      foldGray: true,
      pageGray: true,
      systemBaseUrl: {},
      lastQuestion: '',
      buttonShow: false,
      playAudio: false,
      player: new PCMPlayer({
        encoding: '16bitInt',
        channels: 1,
        sampleRate: 24000,
        flushingTime: 1000,
        onended: function onended(node, event) {
          console.log('1', _this.speechIndex, _this.speechLength - 3);
          if (_this.getSpeechOver && _this.speechIndex > _this.speechLength - 3) {
            _this.pcmOver = true;
            _this.instAnswerMsg[_this.msgClick].play = true;
            _this.speechIndex = 0;
          } else {
            _this.pcmOver = false;
          }
          _this.speechIndex++;
        }
      }),
      pcmOver: true,
      msgClick: -1,
      speechSwitch: localStorage.getItem("".concat(getUserId(), "speechSwitch")) == 1,
      getSpeechOver: false,
      aiLoadingMask: false,
      speechLength: -1,
      speechIndex: 0
    };
  },
  mounted: function mounted() {},
  created: function created() {
    var _this2 = this;
    this.chatId = this.guid();
    this.$API.getRequest({
      url: '/platform/todo/photo'
    }).then(function (res) {
      _this2.images = res.result.imageBase64;
    });
    if (sessionStorage.getItem('layoutColor')) {
      var color = sessionStorage.getItem('layoutColor');
      this.$store.dispatch('settings/changeSetting', {
        key: 'layoutColor',
        value: color
      });
    } else {
      sessionStorage.setItem('layoutColor', '白色');
    }
    if (!sessionStorage.getItem('lang')) {
      sessionStorage.setItem('lang', 'zh');
    }
    if (this.$store.state.settings.layoutColor === '默认') {
      document.getElementsByTagName('body')[0].classList.add('vue-theme-defaultTheme');
    } else {
      document.getElementsByTagName('body')[0].classList.add('vue-theme-whiteTheme');
    }
    this.refreshMessageFn();
    this.refreshTodoFn();
    this.getSystemInnerData();
    this.$API.getRequest({
      url: '/platform/systemInner/list',
      data: {
        pageNum: 1,
        pageSize: 10000
      }
    }).then(function (res) {
      if (res.code === '0000000000') {
        var systemInner = [];
        res.result.records.forEach(function (ele) {
          systemInner.push(ele.systemCategory[0]);
        });
        sessionStorage.setItem('systemInner', JSON.stringify(systemInner));
        _this2.systemList = systemInner;
      }
    }).catch(function (err) {
      _this2.$message.warning(err.message);
    });
    // setBaseurl
    this.$API.getRequest({
      url: '/platform/component/detailInfo',
      data: {
        systemType: 'PC_WEB'
      }
    }).then(function (res) {
      if (res.code === '0000000000') {
        res.result.forEach(function (ele) {
          _this2.systemBaseUrl[ele.systemId] = ele.baseUrl;
        });
      }
      setBaseurl(JSON.stringify(_this2.systemBaseUrl));
    });
  },
  computed: {
    iframeKey: function iframeKey() {
      return this.$store.state.settings.iframeKey;
    },
    sidebar: function sidebar() {
      return this.$store.state.app.sidebar;
    },
    device: function device() {
      return this.$store.state.app.device;
    },
    fixedHeader: function fixedHeader() {
      return this.$store.state.settings.fixedHeader;
    },
    classObj: function classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      };
    },
    user: function user() {
      return this.$store.state.settings.userinfo;
    }
  },
  beforeCreate: function beforeCreate() {
    var _this3 = this;
    var timer = setInterval(function () {
      _this3.refreshMessageFn();
      _this3.refreshTodoFn();
    }, 30000);
    this.$once('hook:beforeDestroy', function () {
      clearInterval(timer);
    });
  },
  methods: {
    speechSwitchChange: function speechSwitchChange(val) {
      this.speechSwitch = val;
      if (val) {
        localStorage.setItem("".concat(getUserId(), "speechSwitch"), 1);
      } else {
        localStorage.setItem("".concat(getUserId(), "speechSwitch"), 0);
      }
    },
    pauseAudio: function pauseAudio() {
      this.player.pause();
      this.instAnswerMsg[this.msgClick].play = true;
      this.pcmOver = false;
    },
    foldEnter: function foldEnter() {
      this.foldGray = false;
    },
    foldLeave: function foldLeave() {
      this.foldGray = true;
    },
    pageEnter: function pageEnter() {
      this.pageGray = false;
    },
    pageLeave: function pageLeave() {
      this.pageGray = true;
    },
    checkModel: function checkModel(model) {
      var _this4 = this;
      if (this.model == model) {
        return;
      }

      // if(this.change){
      //   if(model == 'assistant'){
      //     this.answerMsg.push({
      //           title:[],
      //           msg:'我是小合，您可以问我任何问题。我知道的知识有限，因此我的回答难免出现错误，请您谅解。',
      //           type:'left'
      //         })
      //   }else{
      //     this.answerMsg.push({
      //           msg:'我是小合，您有用的政策咨询助手。我知道的知识有限，因此我的回答难免出现错误，请您谅解。您可以试着这么问我：',
      //           title:[],
      //           qa:['银行审慎监管主要包括哪些方面？','流动资金贷款贷后管理主要包括哪些内容？'],
      //           type:'left'
      //         })
      //   }
      //   this.change = false
      // }else{
      //   if(model == 'assistant'){
      //     this.answerMsg[this.answerMsg.length -1] = {
      //           title:[],
      //           msg:'我是小合，您可以问我任何问题。我知道的知识有限，因此我的回答难免出现错误，请您谅解。',
      //           type:'left'
      //         }
      //   }else{
      //     this.answerMsg[this.answerMsg.length -1] = {
      //           msg:'我是小合，您有用的政策咨询助手。我知道的知识有限，因此我的回答难免出现错误，请您谅解。您可以试着这么问我：',
      //           title:[],
      //           qa:['银行审慎监管主要包括哪些方面？','流动资金贷款贷后管理主要包括哪些内容？'],
      //           type:'left'
      //         }
      //   }
      // }
      setTimeout(function () {
        for (var i = 0; i < 10; i++) {
          _this4.$forceUpdate();
          _this4.add();
          _this4.$forceUpdate();
        }
      });
      this.model = model;
    },
    closeChat: function closeChat() {
      this.drawer = false;
      this.answer = '';
      this.cancelBtn.abort();
    },
    getQuestion: function getQuestion(msg) {
      if (this.disClick) {
        return;
      }
      this.question = msg;
      this.sendBtn();
    },
    sendBtn: function sendBtn() {
      this.answer = '';
      if (this.disClick) {
        return;
      }
      if (this.question.trim().length == 0) {
        this.$message({
          message: '请输入您的问题',
          type: 'warning'
        });
        return;
      }
      // this.change = true
      // if(!this.isSend)this.sendModel = this.model
      // this.isSend = true
      // if(this.model == 'assistant'){
      //   this.sendChat()
      // }else if(this.model == 'instQa'){
      //   this.sendMsgInst()
      // }else{
      //   this.sendMsgRi()
      // }
      this.sendMsgInst();
    },
    toQaStream: function toQaStream() {
      window.open(decodeURIComponent("".concat(window.location.origin, "#/qaStream?sys=").concat(this.chatDraw ? 'assistant' : 'question')));
    },
    cancelQa: function cancelQa() {
      this.disClick = false;
      this.instAnswerMsg[this.instAnswerMsg.length - 1].audio = true;
      this.cancelBtn.abort();
      this.$refs.inputName.focus();
    },
    toInst: function toInst(ele) {
      var path = ele.systemId == 'LC_IE' ? "/instDetail?instId=".concat(ele.id) : "/systemDetails?id=".concat(ele.id);
      this.systemList.forEach(function (item) {
        if (item && item.systemId == ele.systemId) {
          window.open(decodeURIComponent("".concat(window.location.origin, "/?newPage=").concat(item.baseUrl, "&menuPath=").concat(path, "&isHash=").concat(ele.systemId == 'LC_IE' ? 1 : 0)));
        }
      });
      this.model = model;
    },
    add: function add() {
      var div = document.getElementById('instDrawContentScroll');
      // if(this.model == 'assistant'){
      //   div = document.getElementById('drawContentScroll');
      // }else if(this.model == 'instQa'){
      //   div = document.getElementById('instDrawContentScroll');
      // }else if(this.model == 'riQa'){
      //   div = document.getElementById('riDrawContentScroll');
      // }
      div.scrollIntoView({
        block: 'end',
        inline: 'nearest'
      });
      // div.scrollTop = div.scrollHeight;
    },
    carriageReturn: function carriageReturn(event) {
      var e = window.event || arguments[0];
      // console.log(e,e.keyCode)
      if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === 13) {
        e.returnValue = false;
        this.sendBtn();
      }
    },
    guid: function guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-mixed-operators,no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    },
    sendMsgInst: function sendMsgInst() {
      var _this5 = this;
      this.disClick = true;
      var that = this;
      if (this.question.trim().length == 0) {
        this.$message({
          message: '请输入您的问题',
          type: 'warning'
        });
        return;
      }
      this.player.audioCtx && this.player.destroy();
      this.pcmOver = true;
      if (this.msgClick > -1) this.instAnswerMsg[this.msgClick].play = true;
      this.lastQuestion = this.question;
      var url = window.location.href;
      this.instAnswerMsg.push({
        msg: this.question,
        type: 'right',
        title: null,
        images: this.images
      });
      setTimeout(function () {
        for (var i = 0; i < 5; i++) {
          _this5.$forceUpdate();
          _this5.add();
          _this5.$forceUpdate();
        }
      }, 30);
      this.$forceUpdate();
      this.add();
      // eslint-disable-next-line no-unused-vars
      var RetriableError = /*#__PURE__*/function (_Error) {
        _inherits(RetriableError, _Error);
        var _super = _createSuper(RetriableError);
        function RetriableError() {
          _classCallCheck(this, RetriableError);
          return _super.apply(this, arguments);
        }
        return RetriableError;
      }( /*#__PURE__*/_wrapNativeSuper(Error));
      var FatalError = /*#__PURE__*/function (_Error2) {
        _inherits(FatalError, _Error2);
        var _super2 = _createSuper(FatalError);
        function FatalError() {
          _classCallCheck(this, FatalError);
          return _super2.apply(this, arguments);
        }
        return FatalError;
      }( /*#__PURE__*/_wrapNativeSuper(Error));
      var ctrl = new AbortController();
      this.cancelBtn = ctrl;
      this.aiLoadingMask = true;
      fetchEventSource('/assistant/qa/question-stream', {
        // fetchEventSource( 'http://172.19.218.187:9530/hexasino-assistant-qa/qa/question-stream' , {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Connection: 'keep-alive',
          Authorization: "bearer ".concat(getToken())
        },
        body: JSON.stringify({
          session_id: that.guid(),
          //
          query: that.question.trim(),
          // 云闪贷的操作流程
          knowledges: ['internal_clause_knowledge', 'external_clause_knowledge', 'lc_llm'] // instQa
        }),

        openWhenHidden: true,
        retry: false,
        signal: ctrl.signal,
        onopen: function onopen(response) {
          return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    that.aiLoadingMask = false;
                    // that.$refs.msg_end.click();
                    if (response.ok) {
                      that.buttonShow = false;
                      that.question = '';
                      console.log('response', response);
                      that.instAnswerMsg.push({
                        title: [],
                        msg: '',
                        type: 'left',
                        systemId: '',
                        audio: false,
                        play: true,
                        loading: false
                      });
                    }
                  case 2:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }))();
        },
        onmessage: function onmessage(msg) {
          console.log('🚀 ~ file: index.vue:334 ~ onmessage ~ msg:', msg);
          if (msg.data.indexOf('response started') > -1) {
            console.log('🚀 ~ file: index.vue:260 ~ onmessage ~ msg.data:', msg.data);
            var title = msg.data.split('[response started]')[0];
            console.log(eval(title));
            that.instAnswerMsg[that.instAnswerMsg.length - 1].title = eval(title);
          } else {
            console.log(msg.data);
            if (msg.data.indexOf('DONE') > -1) {
              that.answer = '';
              that.buttonShow = true;
              return;
            }
            if (msg.data.indexOf('NEWLINE') > -1) {
              // that.$refs.msg_end.click();
            }
            that.answer += msg.data.replace(/\[NEWLINE\]/g, '<br>');
            that.instAnswerMsg[that.instAnswerMsg.length - 1].msg = that.answer;
            that.$forceUpdate();
            that.add();

            // if the server emits an error message, throw an exception
            // so it gets handled by the onerror callback below:
            if (msg.event === 'FatalError') {
              throw new FatalError(msg.data);
            }
          }
        },
        onclose: function onclose() {
          // if the server closes the connection unexpectedly, retry:
          // that.$refs.msg_end.click();
          that.instAnswerMsg[that.instAnswerMsg.length - 1].audio = true;
          that.disClick = false;
          that.$refs.inputName && that.$refs.inputName.focus();
          if (that.speechSwitch) {
            that.startAudio(that.instAnswerMsg.length - 1);
          }
        },
        onerror: function onerror(err) {
          console.log(3, err);
          that.breakPromise = false;
          // that.$refs.searchInput.focus()
          throw new FatalError('xxx');
        }
      });
    },
    sendMsgRi: function sendMsgRi() {
      var _this6 = this;
      this.disClick = true;
      this.question = this.lastQuestion;
      var that = this;
      if (this.question == '') {
        this.$message({
          message: '请输入您的问题',
          type: 'warning'
        });
        return;
      }
      this.player.audioCtx && this.player.destroy();
      this.pcmOver = true;
      if (this.msgClick > -1) this.instAnswerMsg[this.msgClick].play = true;
      var url = window.location.href;
      // this.instAnswerMsg.push({msg:this.question,type:'right',title:null,images:this.images})
      setTimeout(function () {
        for (var i = 0; i < 5; i++) {
          _this6.$forceUpdate();
          _this6.add();
          _this6.$forceUpdate();
        }
      }, 30);
      this.$forceUpdate();
      this.add();
      var RetriableError = /*#__PURE__*/function (_Error3) {
        _inherits(RetriableError, _Error3);
        var _super3 = _createSuper(RetriableError);
        function RetriableError() {
          _classCallCheck(this, RetriableError);
          return _super3.apply(this, arguments);
        }
        return RetriableError;
      }( /*#__PURE__*/_wrapNativeSuper(Error));
      var FatalError = /*#__PURE__*/function (_Error4) {
        _inherits(FatalError, _Error4);
        var _super4 = _createSuper(FatalError);
        function FatalError() {
          _classCallCheck(this, FatalError);
          return _super4.apply(this, arguments);
        }
        return FatalError;
      }( /*#__PURE__*/_wrapNativeSuper(Error));
      var ctrl = new AbortController();
      this.cancelBtn = ctrl;
      this.aiLoadingMask = true;
      fetchEventSource('/assistant/qa/question-stream', {
        // fetchEventSource( 'http://172.19.218.187:9530/hexasino-assistant-qa/qa/question-stream' , {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Connection: 'keep-alive',
          Authorization: "bearer ".concat(getToken())
        },
        body: JSON.stringify({
          session_id: that.guid(),
          //
          query: that.question.trim(),
          // 云闪贷的操作流程
          knowledges: ['external_clause_knowledge'] // instQa
        }),

        openWhenHidden: true,
        retry: false,
        signal: ctrl.signal,
        onopen: function onopen(response) {
          return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    that.aiLoadingMask = false;
                    // that.$refs.msg_end.click();
                    if (response.ok) {
                      that.question = '';
                      console.log('response', response);
                      that.instAnswerMsg.push({
                        title: [],
                        msg: '',
                        type: 'left',
                        audio: false,
                        play: true,
                        loading: false
                      });
                    }
                  case 2:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }))();
        },
        onmessage: function onmessage(msg) {
          console.log('🚀 ~ file: index.vue:334 ~ onmessage ~ msg:', msg);
          if (msg.data.indexOf('response started') > -1) {
            console.log('🚀 ~ file: index.vue:260 ~ onmessage ~ msg.data:', msg.data);
            var title = msg.data.split('[response started]')[0] || null;
            console.log(eval(title));
            that.instAnswerMsg[that.instAnswerMsg.length - 1].title = eval(title);
          } else {
            console.log(msg.data);
            if (msg.data.indexOf('DONE') > -1) {
              that.answer = '';
              return;
            }
            if (msg.data.indexOf('NEWLINE') > -1) {
              // that.$refs.msg_end.click();
            }
            that.answer += msg.data.replace(/\[NEWLINE\]/g, '<br>');
            that.instAnswerMsg[that.instAnswerMsg.length - 1].msg = that.answer;
            that.$forceUpdate();
            that.add();

            // if the server emits an error message, throw an exception
            // so it gets handled by the onerror callback below:
            if (msg.event === 'FatalError') {
              throw new FatalError(msg.data);
            }
          }
        },
        onclose: function onclose() {
          // if the server closes the connection unexpectedly, retry:
          // that.$refs.msg_end.click();

          that.instAnswerMsg[that.instAnswerMsg.length - 1].audio = true;
          that.disClick = false;
          if (that.speechSwitch) {
            that.startAudio(that.instAnswerMsg.length - 1);
          }
        },
        onerror: function onerror(err) {
          console.log(3, err);
          that.breakPromise = false;
          // that.$refs.searchInput.focus()
          throw new FatalError('xxx');
        }
      });
    },
    startAudio: function startAudio(index) {
      var _this7 = this;
      if (this.msgClick == index) {
        if (!this.pcmOver) {
          this.player.continue();
          this.instAnswerMsg[index].play = false;
          return;
        }
      }
      if (this.msgClick != -1) this.instAnswerMsg[this.msgClick].play = true;
      this.msgClick = index;
      this.player.audioCtx && this.player.destroy();
      this.getSpeechOver = false;
      this.speechIndex = 0;
      this.player = new PCMPlayer({
        encoding: '16bitInt',
        channels: 1,
        sampleRate: 24000,
        flushingTime: 1000,
        onended: function onended(node, event) {
          console.log('2', _this7.speechIndex, _this7.speechLength - 3);
          if (_this7.getSpeechOver && _this7.speechIndex >= _this7.speechLength - 3) {
            _this7.pcmOver = true;
            _this7.instAnswerMsg[index].play = true;
            _this7.speechIndex = 0;
          } else {
            _this7.pcmOver = false;
          }
          _this7.speechIndex++;
        }
      });
      this.pcmOver = false;
      this.player.volume(3);
      this.instAnswerMsg[index].play = false;
      this.instAnswerMsg[index].loading = true;
      var speechList = this.instAnswerMsg[index].msg.split(/<br\s*\/?>+/gi).filter(function (part) {
        return part.trim() !== '';
      });
      this.speechLength = speechList.length;
      this.getSpeech(speechList, index);
    },
    getSpeech: function getSpeech(speechList, index) {
      var _this8 = this;
      if (this.msgClick !== index) {
        return;
      }
      if (speechList.length > 0) {
        this.$API.postRequest({
          url: '/assistant/qa/tts',
          headers: {
            'Content-Type': 'application/json' // Indicates the content type is JSON
          },

          data: {
            input: speechList.shift().replace(/[\r\n*]/g, '')
          },
          responseType: 'text'
        }).then( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(response) {
            var rawBase64, base64ToUint8Array;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    base64ToUint8Array = function _base64ToUint8Array(base64String) {
                      var padding = '='.repeat((4 - base64String.length % 4) % 4);
                      var base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
                      var rawData = window.atob(base64);
                      var outputArray = new Uint8Array(rawData.length);
                      for (var i = 0; i < rawData.length; ++i) {
                        outputArray[i] = rawData.charCodeAt(i);
                      }
                      return outputArray;
                    };
                    _this8.instAnswerMsg[index].loading = false;
                    rawBase64 = '';
                    if (!(_this8.msgClick !== index)) {
                      _context3.next = 5;
                      break;
                    }
                    return _context3.abrupt("return");
                  case 5:
                    _this8.player.feed(base64ToUint8Array(response));
                    _context3.next = 8;
                    return _this8.sleep(100);
                  case 8:
                    _this8.getSpeech(speechList, index);
                    // function processChunk({ done, value }) {
                    //   if (done) {
                    //     console.log('Stream complete');
                    //     // Once the stream is fully read, use the atob() function to decode the
                    //     // base64 string to binary data, or pass the base64 to a function that can handle it
                    //     //let decodedData = atob(rawBase64);
                    //     let decodedData = base64ToUint8Array(rawBase64);
                    //     // Handle the binary data here...
                    //     return decodedData;
                    //   }

                    //   // Decode each chunk of data as it comes in and add it to the rawBase64 string
                    //   let base64Chunk = (new TextDecoder()).decode(value, { stream: true });
                    //   rawBase64 += base64Chunk;

                    //   // Log the base64 chunk received
                    //   console.log('Received a chunk of base64 data');

                    //   // Use the reader to read the next chunk
                    //   return reader.read().then(processChunk);
                    // }

                    // return reader.read().then(processChunk);
                  case 9:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()).catch(function (data) {
          _this8.instAnswerMsg[index].play = true;
          // player.feed(data);
        });
      } else {
        this.getSpeechOver = true;
      }
    },
    sleep: function sleep(delay) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", new Promise(function (resolve, reject) {
                  setTimeout(function () {
                    try {
                      resolve(1);
                    } catch (e) {
                      reject(0);
                    }
                  }, delay);
                }));
              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    clearSessionId: function clearSessionId() {
      var _this9 = this;
      return new Promise(function (resolve) {
        // $.ajax({
        //   type:"post",
        //   url:'/assistant/clear_session/'+`${sessionId}`,
        //   success:function(res){
        //     if(res.code === '200'){
        //       resolve(res)
        //     }
        //   }
        // })
        _this9.$API.postRequest({
          // eslint-disable-next-line no-useless-concat
          url: '/assistant/clear_session/' + "".concat(chatId)
        }).then(function (res) {
          if (res.code === '200') {
            resolve(res);
          }
        });
      });
    },
    sendChat: function sendChat() {
      var _this10 = this;
      this.disClick = true;
      var that = this;
      if (this.question === '') {
        this.$message({
          message: '请输入您的问题',
          type: 'warning'
        });
        return;
      }
      // eslint-disable-next-line no-unused-vars
      var url = window.location.href;
      this.answerMsg.push({
        msg: this.question,
        type: 'right',
        title: null,
        images: this.images
      });
      setTimeout(function () {
        for (var i = 0; i < 5; i++) {
          _this10.$forceUpdate();
          _this10.add();
          _this10.$forceUpdate();
        }
      }, 30);
      // eslint-disable-next-line no-unused-vars
      var RetriableError = /*#__PURE__*/function (_Error5) {
        _inherits(RetriableError, _Error5);
        var _super5 = _createSuper(RetriableError);
        function RetriableError() {
          _classCallCheck(this, RetriableError);
          return _super5.apply(this, arguments);
        }
        return RetriableError;
      }( /*#__PURE__*/_wrapNativeSuper(Error));
      var FatalError = /*#__PURE__*/function (_Error6) {
        _inherits(FatalError, _Error6);
        var _super6 = _createSuper(FatalError);
        function FatalError() {
          _classCallCheck(this, FatalError);
          return _super6.apply(this, arguments);
        }
        return FatalError;
      }( /*#__PURE__*/_wrapNativeSuper(Error));
      var ctrl = new AbortController();
      this.cancelBtn = ctrl;
      fetchEventSource('/assistant/chat', {
        // fetchEventSource( 'http://172.19.218.187:9530/hexasino-assistant-qa/qa/question-stream' , {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Connection: 'keep-alive',
          Authorization: "bearer ".concat(getToken())
        },
        body: JSON.stringify({
          session_id: that.chatId,
          //
          prompt: that.question.trim() // 云闪贷的操作流程
        }),

        openWhenHidden: true,
        retry: false,
        signal: ctrl.signal,
        onopen: function onopen(response) {
          return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    // that.$refs.msg_end.click();
                    if (response.ok) {
                      that.question = '';
                      that.answerMsg.push({
                        title: [],
                        msg: '',
                        type: 'left'
                      });
                    }
                  case 1:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          }))();
        },
        onmessage: function onmessage(msg) {
          that.$nextTick(function () {
            // setTimeout(()=>{
            if (msg.data.indexOf('DONE') > -1) {
              that.answer = '';
              return;
            }
            that.answer += msg.data.replace(/\[NEWLINE\]/g, '<br>');
            that.answerMsg[that.answerMsg.length - 1].msg = that.answer;
            that.$forceUpdate();
            that.add();
            // },100)
          });

          // if the server emits an error message, throw an exception
          // so it gets handled by the onerror callback below:
          if (msg.event === 'FatalError') {
            throw new FatalError(msg.data);
          }
        },
        onclose: function onclose() {
          // if the server closes the connection unexpectedly, retry:
          // that.$refs.msg_end.click();
          that.disClick = false;
          that.$refs.inputName.focus();
        },
        onerror: function onerror() {
          that.breakPromise = false;
          // that.$refs.searchInput.focus()
          throw new FatalError('xxx');
        }
      });
    },
    closeQuestion: function closeQuestion() {
      this.drawer = false;
    },
    toCreatePage: function toCreatePage(type) {
      if (type === 'ASSISTANT') {
        this.chatDraw = !this.chatDraw;
        this.drawer = false;
      } else {
        this.drawer = !this.drawer;
        this.chatDraw = false;
      }
      this.isShowBtnGroup = false;
    },
    SelectFunc: function SelectFunc() {
      this.drawer = !this.drawer;
    },
    handleClickOutside: function handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', {
        withoutAnimation: false
      });
    },
    refreshMessageFn: function refreshMessageFn() {
      var _this11 = this;
      refreshMessage().then(function (res) {
        var code = res.code,
          result = res.result;
        if (code === '0000000000') {
          _this11.setMessage(result);
        }
      });
    },
    refreshTodoFn: function refreshTodoFn() {
      var _this12 = this;
      refreshTodo().then(function (res) {
        var code = res.code,
          result = res.result;
        if (code === '0000000000') {
          _this12.setTodo(result);
        }
      });
    },
    // 设置未读消息数
    setMessage: function setMessage(message) {
      localStorage.setItem('MESSAGE_UPDATE_EVENT', message);
      this.$store.dispatch('message/setMessage', message);
    },
    //
    setTodo: function setTodo(todo) {
      localStorage.setItem('TODO_UPDATE_EVENT', todo);
      this.$store.dispatch('message/setTodo', todo);
    },
    // 获取系统名称数据
    getSystemInnerData: function getSystemInnerData() {
      getSystemInnerList().then(function (res) {
        var code = res.code,
          result = res.result;
        if (code === '0000000000') {
          var systemNameArr = result.records.map(function (_ref2) {
            var systemName = _ref2.systemName,
              systemId = _ref2.systemId;
            return {
              label: systemName,
              value: systemId
            };
          });
          localStorage.setItem('SYSTEM_NAME_ARR', JSON.stringify(systemNameArr));
        }
      });
    },
    // 机器人弹框的显示与否事件函数
    robotModalController: function robotModalController() {
      this.robotModalVisible = !this.robotModalVisible;
    }
  }
};